import { get, isBoolean, noop } from 'lodash'
import React from 'react'
import styled from 'styled-components'

import Icon from '../Icon'
import Tooltip from '../Tooltip'
import { getIcon } from './helpers'

const Wrapper = styled.div`
  cursor: pointer;
`

type TCheckbox = {
  id?: string
  /** Checked if truthy value  */
  value?: boolean | string | number
  /** Callback when click on the icon */
  onChange?: (val: string | boolean) => void
  /** Label of the checkbox */
  label?: React.ReactNode

  /** Same as label prop */
  children?: React.ReactNode

  /** Show icon and label in the same line */
  inline?: boolean

  /** Set display block */
  block?: boolean

  /** content of the tooltip of checkbox */
  tooltip?: string

  /** When true, set icon size bigger */
  large?: boolean

  /** Disable check box */
  disabled?: boolean

  /** Css class name of the wrapper */
  name?: string

  /** only display check box icon and label without any interaction handling */
  isStatic?: boolean

  /** Class name of font icon */
  icon?: string

  /** Class name of font icon on toolip */
  iconTooltip?: string
  /* if true will prevent uncheck when current value true */
  preventUncheck?: boolean
  iconSize?: string
}

const Checkbox = (props: TCheckbox): React.ReactElement => {
  const {
    value,
    onChange = noop,
    inline = true,
    block,
    label,
    children,
    tooltip,
    large,
    disabled = false,
    name = 'generic-checkbox',
    isStatic,
    icon = 'fas fa-check',
    preventUncheck = false,
    iconTooltip = 'mdi mdi-help-circle',
    iconSize,
    id,
  } = props

  const onClick = (): void => {
    if (disabled) return

    get(props, 'onClick', noop)()

    if (isBoolean(value)) {
      if (!value || !preventUncheck) {
        onChange(!value)
      }
    } else if (
      value === '' ||
      value === 'false' ||
      value === undefined ||
      value === null ||
      value === 'indeterminate' ||
      value === 0
    ) {
      onChange(true)
    } else if (!preventUncheck) {
      onChange(false)
    }
  }

  if (isStatic) {
    return (
      <div>
        <Icon icon={icon} /> {label || children}
      </div>
    )
  }

  let checkboxValue: string | boolean = false

  if (value === 'indeterminate') {
    checkboxValue = 'indeterminate'
  }
  if (value === 'true' || value === true || value === 1) {
    checkboxValue = true
  }

  return (
    <Tooltip tooltip={tooltip}>
      <Wrapper
        onClick={onClick}
        className={`1stlog-checkbox ${name} ${
          !block ? 'd-inline-block' : 'd-block'
        } ${!block ? 'mr-2' : ''}`}
      >
        {!inline && <label>{label}</label>}

        <div className="d-flex align-items-center">
          <div style={{ position: 'relative', lineHeight: '1' }}>
            <div style={{ position: 'absolute' }}>
              <Icon
                icon={`${getIcon(checkboxValue)} ${
                  disabled ? 'text-muted' : ''
                }`}
                style={large ? { fontWeight: 200 } : {}}
                size={iconSize || (large ? 1.7 : 1.1)}
              />
            </div>

            <div style={{ color: 'white' }}>
              <Icon
                icon=" fas fa-square"
                style={large ? { fontWeight: 200 } : {}}
                size={iconSize || (large ? 1.7 : 1.1)}
              />
            </div>
          </div>

          {(label || children) && (
            <div className={`ml-1 ${disabled ? 'text-muted' : ''}`}>
              {inline && (label || children)}
              {tooltip && iconTooltip && (
                <i className={`ml-1 ${iconTooltip}`} />
              )}
            </div>
          )}
        </div>
      </Wrapper>
    </Tooltip>
  )
}

export default Checkbox
